/* eslint-disable */
export default class BaseAdapter {
  static persistBy = 'insertOrUpdate'

  constructor({ data = null, parent = null } = {}) {
    this.loading = false
    this.parent = parent
    this.newRecord = data ? false : true
    this.data = data ?? new this.constructor.model()
  }

  loadFromStore({ id = null } = {}) {
    let cls = this.constructor
    let data = id
      ? cls.model.query().whereId(id).withAllRecursive().first()
      : cls.model.query().withAllRecursive().first()
    if (data) {
      this.data = data
      this.newRecord = false
    }
  }

  async loadFromApi({ id = null } = {}) {
    let cls = this.constructor
    this.loading = true
    this.data[cls.model.primaryKey] = id // set primaryKey value before calling url getter
    let response = await cls.model.apiFetch({ url: this.url, save: false })
    if (response && response.data) {
      await this._persist(response.data)
    }
    this.loadFromStore({ id: id })
    this.loading = false
  }

  async load({ id = null, includes = [] } = {}) {
    this.loadFromStore({ id: id })
    if (this.newRecord) {
      await this.loadFromApi({ id: id })
    }
    await this._loadRelationships(includes)
  }

  async create() {
    let response = await this.data.apiCreate({ url: this.url })
    if (response) {
      if (this._afterCreate != undefined) {
        await this._afterCreate(response)
      }
      return true
    }
    return false
  }

  async update() {
    let saved = await this.data.apiUpdate({ url: this.url })
    if (saved) {
      if (this._afterUpdate != undefined) {
        await this._afterUpdate()
      }
      return true
    }
    return false
  }

  async _loadRelationships(includes) {
    let cls = this.constructor
    if (!this.newRecord) {
      for (let rel of includes) {
        if (cls.relationships.includes(rel)) {
          await eval(`this.${rel}.load()`)
        }
      }
    }
  }

  // persist

  async _persist(data) {
    let cls = this.constructor
    if (this._beforePersist != undefined) {
      await this._beforePersist(data)
    }
    cls.model.insertOrUpdate({ data: data })
  }
}
